import { useEffect, useRef, useState } from 'react';
import { type VoiceSettingsDialogState } from '#speaker-shop/components/VoiceSettingsDialog.tsx';

export const useElevenLabsControls = (defaultAudioControls: VoiceSettingsDialogState, resetKey?: string) => {
    const [ voiceSettings, setVoiceSettings ] = useState<VoiceSettingsDialogState | null>(null);
    const previousResetKey = useRef(resetKey);

    useEffect(() => {
        if (previousResetKey.current !== resetKey) {
            previousResetKey.current = resetKey;
            setVoiceSettings(defaultAudioControls);
            return;
        }

        setVoiceSettings(current => current ?? defaultAudioControls);
    }, [ defaultAudioControls, resetKey ]);

    return { voiceSettings, setVoiceSettings };
};
